import React, { useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Select from "react-select";
import { Editor } from "react-draft-wysiwyg";

// styles
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// components
import PageTitle from "../../../../components/PageTitle";
import FileUploader from "../../../../components/FileUploader";
import { FormInput } from "../../../../components/";

const Addlead = () => {
  const [editorState, setEditorState] = useState<any>();
  const categories = [
    {
      label: "Branch",
      options: [
        { value: "SH1", label: "Garigel 1" },
        { value: "SH2", label: "Garigel 2" },
        { value: "SH3", label: "Garigel 3" },
      ],
    },
    {
      label: "Campaign Type",
      options: [
        { value: "E1", label: "Online" },
        { value: "E2", label: "Offline" },
        { value: "E3", label: "Email" },
        { value: "E4", label: "Social Media" },
      ],
    },
    {
      label: "Industry",
      options: [
        { value: "E1", label: "Banking" },
        { value: "E2", label: "Retailer" },
        { value: "E3", label: "Telecom" },
        { value: "E4", label: "Information Technology" },
        { value: "E5", label: "Consulting" },
        { value: "E6", label: "Electronics" },
      ],
    },
  ];

  const schemaResolver = yupResolver(
    yup.object().shape({
      name: yup.string().required("Please enter Project Name"),
      reference: yup.string().required("Please enter Project Name"),
      summary: yup.string().required("Please enter Project Name"),
      price: yup.string().required("Please enter Project Name"),
      comment: yup.string().required("Please enter Project Name"),
      metatitle: yup.string().required("Please enter Project Name"),
      metakeywords: yup.string().required("Please enter Project Name"),
      metadescription: yup.string().required("Please enter Project Name"),
    })
  );

  const methods = useForm({ resolver: schemaResolver });
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = methods;

  const onEditorStateChange = (editorStates: any) => {
    setEditorState(editorStates);
  };

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: "Ecommerce", path: "/apps/ecommerce/details" },
          {
            label: "Add / Edit Product",
            path: "/apps/ecommerce/details",
            active: true,
          },
        ]}
        title={"Add Lead "}
      />

      <form onSubmit={handleSubmit(() => {})}>
        <Row>
          <Col lg={6}>
            <Card>
              <Card.Body>
                <h5 className="text-uppercase bg-light p-2 mt-0 mb-3">
                  User Information
                </h5>
                <Row className="mb-3">
                  <Col xs={12} sm={6}>
                    <FormInput
                      name="firstName"
                      label="First Name :*"
                      placeholder=""
                      containerClass={"mb-3"}
                      register={register}
                      key="firstName"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <FormInput
                      name="lastName"
                      label="Last Name :*"
                      placeholder=""
                      containerClass={"mb-3"}
                      register={register}
                      key="lastName"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>

                <FormInput
                  name="email"
                  label="Email :*"
                  placeholder=""
                  containerClass={"mb-3"}
                  register={register}
                  key="email"
                  errors={errors}
                  control={control}
                />
                <FormInput
                  type="number"
                  name="mobileNumber"
                  label="Mobile Number :*"
                  placeholder=""
                  containerClass={"mb-3"}
                  register={register}
                  key="mobileNumber"
                  errors={errors}
                  control={control}
                />
                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Editor
                    editorState={editorState}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName border border-1"
                    editorClassName="editorClassName px-2"
                    onEditorStateChange={onEditorStateChange}
                    editorStyle={{ minHeight: "150px" }}
                  />
                </Form.Group>
              </Card.Body>
            </Card>
            <Card>
              <Card.Body>
                <h5 className="text-uppercase mt-0 mb-3 bg-light p-2">
                  Lead Information
                </h5>
                <Form.Group className="mb-3">
                  <Form.Label>Branch :*</Form.Label>
                  <Select
                    className="react-select react-select-container"
                    classNamePrefix="react-select"
                    options={categories}
                    id="product-category"
                  />
                </Form.Group>
                <Row className="mb-3">
                  <Col xs={12} sm={6}>
                    <Form.Group>
                      <Form.Label>Campaign :*</Form.Label>
                      <Select
                        className="react-select react-select-container"
                        classNamePrefix="react-select"
                        options={categories}
                        id="product-category"
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Group>
                      <Form.Label>Industry:</Form.Label>
                      <Select
                        className="react-select react-select-container"
                        classNamePrefix="react-select"
                        options={categories}
                        id="product-category"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={6}>
            <Card>
              <Card.Body>
                <h5 className="text-uppercase mt-0 mb-3 bg-light p-2">
                  Lead Images
                </h5>
                <FileUploader />
              </Card.Body>
            </Card>
            <Card>
              <Card.Body>
                <h5 className="text-uppercase bg-light p-2 mt-0 mb-3">
                  Address Information
                </h5>

                <FormInput
                  name="address"
                  label="Address:"
                  placeholder=""
                  containerClass={"mb-3"}
                  register={register}
                  key="address"
                  errors={errors}
                  control={control}
                />
                <Row className="mb-3">
                  <Col xs={12} sm={6}>
                    <FormInput
                      name="postalCode"
                      label="Postal Code:"
                      placeholder=""
                      containerClass={"mb-3"}
                      register={register}
                      key="postalCode"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <FormInput
                      name="city"
                      label="City:"
                      placeholder=""
                      containerClass={"mb-3"}
                      register={register}
                      key="city"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>
                <FormInput
                  name="state"
                  label="State:"
                  placeholder=""
                  containerClass={"mb-3"}
                  register={register}
                  key="state"
                  errors={errors}
                  control={control}
                />
                <Row className="mb-3">
                  <Col xs={12} sm={6}>
                    <FormInput
                      name="country"
                      label="Country:"
                      placeholder=""
                      containerClass={"mb-3"}
                      register={register}
                      key="country"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <FormInput
                      name="fax"
                      label="Fax:"
                      placeholder=""
                      containerClass={"mb-3"}
                      register={register}
                      key="fax"
                      errors={errors}
                      control={control}
                    />
                  </Col>
                </Row>
                <FormInput
                  name="company"
                  label="Company:"
                  placeholder="e.g The Vista One"
                  containerClass={"mb-3"}
                  register={register}
                  key="company"
                  errors={errors}
                  control={control}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col
            lg={12}
            className="d-flex align-items-center justify-content-center mb-2"
          >
            <button className="btn btn-primary">Submit </button>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default Addlead;
